export default class AutomaticScoutSetting {
  ready() {
    const $this = this;
    function initializeNumberField($group) {
      const $input = $group.find('input[type="number"]');
      const $minusBtn = $group.find('.btn-minus-automatic-scout-limit');
      const $plusBtn = $group.find('.btn-plus-automatic-scout-limit');
      const max = parseInt($input.attr('max'));
      const min = parseInt($input.attr('data-min'));
      const form = $('#form-setting-automatic-scout-limit');
      const formCompany = $('#form-company-setting-automatic-scout-limit');
      const popupScoutDetail = $('.scout-submission-content');
      const tableSummary = $('table.table-summary-scout-setting');
      const numberAvailable = $('#number-available');
      const numberSetting = $('#number-setting');
      const btnSettingLimit = $('#company-setting-limit');

      function updateButtonStates() {
        const value = parseInt($input.val());

        if ($input.val() != '' && btnSettingLimit.length > 0) {
          btnSettingLimit.prop('disabled', false);
        } else {
          btnSettingLimit.prop('disabled', true);
        }

        $minusBtn.prop('disabled', value <= Math.max(0, min));

        if (form.length > 0) {
          let available = parseInt(form.attr('data-available'));
          $plusBtn.prop('disabled', available == 0);
          $('.btn-plus-automatic-scout-limit').prop('disabled', available <= 0);
          $('.btn-plus-automatic-scout-limit').data('auto', available > 0 ? 'on' : 'off');
          if ($plusBtn.data().auto == 'off') $plusBtn.prop('disabled', true);
        } else {
          $plusBtn.prop('disabled', value >= max);
        }

        if (value <= Math.max(0, min) || ($input.val() == '' && Math.max(0, min) > 0)) {
          $input.addClass('alert-danger');
          if ($input.data('not-set-limit') && $input.data('show-alert')) {
            $input.addClass('alert-danger');
          } else if (!$input.data('make-bg') && value == Math.max(0, min)) {
            $input.removeClass('alert-danger');
          }
        } else {
          $input.removeClass('alert-danger');
          if ($input.data('current') == value && $input.data('show-alert')) $input.addClass('alert-danger');
        }
      }

      function validateAndSetValue(newValue) {
        if (form.length > 0) {
          let available = parseInt(form.attr('data-available'));
          let oldVal = parseInt($input.data('old'));

          if (available && (oldVal - newValue) < 0) {
            available += (newValue + (oldVal - newValue));
          }

          if (available && oldVal < newValue) {
            newValue = Math.max(0, Math.min(newValue, available));
          } else if (!available) {
            newValue = Math.max(0, Math.min(newValue, oldVal));
          } else {
            newValue = Math.max(0, Math.min(newValue, max));
          }
        } else {
          newValue = Math.max(0, Math.min(newValue, max));
        }

        $input.val(newValue);
      }

      function updateAutomaticSetting(elem) {
        if (form.length > 0) {
          let available = parseInt(form.attr('data-available'));
          let setting = parseInt(form.attr('data-setting'));
          let newVal = $input.val() ? parseInt($input.val()) : 0;

          if (elem.hasClass('btn-plus-automatic-scout-limit')) {
            setting = setting + 1;
            available = available - 1;
          }

          if (newVal >= min && elem.hasClass('btn-minus-automatic-scout-limit')) {
            available = available + 1;
            setting = setting - 1;
          }

          if (elem.is('input')) {
            let oldVal = parseInt($input.data('old'));
            let difference = newVal - oldVal;
            setting = setting + difference;
            available = available - difference;
          }

          numberSetting.text(setting);
          numberAvailable.text(available);

          form.data('available', available);
          form.attr('data-available', available);
          form.data('setting', setting);
          form.attr('data-setting', setting);
          $input.data('old', newVal);
          $input.attr('data-old', newVal);

          if (available == 0) {
            form.find('button.btn-plus-automatic-scout-limit[data-auto=on]').prop('disabled', true);
            if (setting != 0) numberSetting.addClass('text-danger').removeClass('text-primary');
          } else {
            form.find('button.btn-plus-automatic-scout-limit[data-auto=on]').prop('disabled', false);
            numberSetting.addClass('text-primary').removeClass('text-danger');
          }
        } else if (formCompany.length > 0 && gon.company_scout_details && tableSummary) {
          let newVal = $input.val() ? parseInt($input.val()) : 0;
          let details = gon.company_scout_details;

          details.total_auto_setting = newVal;
          details.total_auto_available = Math.max(0, newVal - details.total_auto_used);

          if (newVal > details.total_auto_used) {
            details.total_manual_setting = Math.max(0, details.total_scout - newVal);
            details.total_manual_available = Math.max(0, details.total_manual_setting - details.total_manual_used);
          } else {
            details.total_manual_setting = Math.max(0, details.total_scout - details.total_auto_used);
            details.total_manual_available = Math.max(0, details.total_manual_setting - details.total_manual_used);
          }

          if (tableSummary.length > 0) {
            let automaticRow = tableSummary.find('tr.automatic-scout');
            let manualRow = tableSummary.find('tr.manual-scout');

            automaticRow.find('.setting').text(newVal);
            automaticRow.find('.available').text(details.total_auto_available);
            manualRow.find('.setting').text(details.total_manual_setting);
            manualRow.find('.available').text(details.total_manual_available);
          }

          if (popupScoutDetail.length > 0) {
            let automaticRow = popupScoutDetail.find('.automatic-scout');
            let automaticLimit = automaticRow.find('.limit');
            let manualRow = popupScoutDetail.find('.manual-scout');

            automaticLimit.text(` / ${newVal}`);
            manualRow.find('.limit').text(` / ${details.total_manual_setting}`);

            if (newVal > 0) {
              automaticLimit.removeClass('invisible');
            } else {
              automaticLimit.addClass('invisible');
            }
          }
        }
      }

      $input.on('input', function () {
        if ($input.val()) {
          let val = $input.val() ? $input.val() : 0;
          validateAndSetValue(parseInt(val));
        }
        updateAutomaticSetting($(this));
        updateButtonStates();
      });

      $minusBtn.on('click', function () {
        let val = $input.val() ? $input.val() : 0;
        validateAndSetValue(parseInt(val) - 1);
        updateAutomaticSetting($(this));
        updateButtonStates();
      });

      $plusBtn.on('click', function () {
        let val = $input.val() ? $input.val() : 0;
        validateAndSetValue(parseInt(val) + 1);
        updateAutomaticSetting($(this));
        updateButtonStates();
      });

      if (!form.length) {
        updateButtonStates();
      }
    }

    $(document).ready(function () {
      $('.js-number-automatic-scout-limit-wrapper').each(function () {
        initializeNumberField($(this));
      });

      let modalConfirmationResetSetting = $('#modalConfirmationResetSetting');

      $('.btn-discard-automatic-scout-limit').on('click', function () {
        let profileId = modalConfirmationResetSetting.data('uid');
        let currentItemId = $(this).data('id');
        let endpoint = `/${gon.locale}/company_profiles/${profileId}/automatic_scout_settings/${currentItemId}`;
        modalConfirmationResetSetting.modal();
        modalConfirmationResetSetting.data('id', currentItemId);
        modalConfirmationResetSetting.attr('data-id', currentItemId);
        modalConfirmationResetSetting.find('#btnConfirmReset').attr('href', endpoint);
      });

      $this.showNoticeMessageOffAutoScout();

      setTimeout(() => { $('.alert-success[role="alert"]').find('.close[data-dismiss="alert"]').click() }, 5000);
    });
  }

  changeAutomaticScoutSetting(inp, autoScoutId, profileId) {
    if ($(inp).is(':checked')) {
      $(inp).closest('td').find('a.open-popup').click();
      $(inp).prop('checked', false);
      return;
    }

    const URL = `/company_profiles/${profileId}/automatic_scout_settings/${autoScoutId}`

    $.ajax({
      url: URL,
      method: 'PUT',
      dataType: 'json',
      data: { is_active: 0 },
      success: (res) => {
        console.log('Turn off automatic scout successfully!!!');
        localStorage.setItem('automaticScoutSettingOff', true);
        window.location.href = location.href;
      },
      error: (err) => {
        console.error('Turn off automatic scout failed!!!');
      }
    })
  }

  enabledLimitSetting(elem) {
    let curEle = $(elem);
    let thisDataCell = curEle.closest('td');
    let actionGroup = thisDataCell.find('.number-automatic-scout-limit-wrapper');

    curEle.addClass('d-none');
    curEle.removeClass('d-flex');
    actionGroup.removeClass('d-none');
    actionGroup.addClass('d-flex');
    actionGroup.find('input.automatic-scout-limit-number-field').prop('disabled', false);
  }

  showNoticeMessageOffAutoScout() {
    if (!localStorage.getItem('automaticScoutSettingOff')) return;

    let renderMessage = $('.alert-message[data-render=message]');

    let msgHtml = '<div class="row"><div class="col-12">';
    msgHtml += '<div class="alert alert-success text-success text-center mb-3" role="alert">';
    msgHtml += `<span>${gon.views.shared.notices.save_change}</span>`;
    msgHtml += '<button type="button" class="close outline-0 shadow-0" data-dismiss="alert" aria-label="Close">';
    msgHtml += '<span aria-hidden="true"> &times;</span>';
    msgHtml += '</button>';
    msgHtml += '</div></div></div>';
    renderMessage.html(msgHtml);
    localStorage.removeItem('automaticScoutSettingOff');

    if (!renderMessage.data('scroll') || renderMessage.data('scroll') == "false") return;

    $('html, body').animate({
      scrollTop: renderMessage.offset().top - window.innerHeight + 250
    }, 500);
  }
}
